export default "__VITE_ASSET__BBxnqJbb__"